<div class="contenedor-detalle-apartamento" [ngSwitch]="actual">
  <app-grupo-botones [seleccionado]="actual" [botones]="opciones"
    (funcionEvent)="handleOpcion($event)"></app-grupo-botones>

  <form class="formulario-titular" *ngSwitchCase="opciones[0]" [formGroup]="titularForm">
    <div class="formulario-titular-grilla">
      <!-- <span *ngIf="nombreTitular">Nombre ocupante</span><input formControlName="nombreTitular" type="text"
        *ngIf="nombreTitular" readonly> -->
      <span>Tipo de documento</span>
      <input *ngIf="titularAsignado" formControlName="tipoDocumento" type="text" readonly>
      <mat-select *ngIf="!titularAsignado" formControlName="tipoDocumento" placeholder="Seleccione"
        [class.required]="titularForm.get('tipoDocumento').invalid && titularForm.get('tipoDocumento').touched">
        <mat-option *ngFor="let tipo of tiposDeDocumentos" [value]="tipo">{{tipo}}</mat-option>
      </mat-select>

      <span>Documento</span>
      <input formControlName="documento" type="number" [readonly]="titularAsignado"
        [class.required]="titularForm.get('documento').invalid && titularForm.get('documento').touched">

      <span>Nombres</span>
      <input formControlName="nombres" type="text" [readonly]="titularAsignado"
        [class.required]="titularForm.get('nombres').invalid && titularForm.get('nombres').touched">

      <span>Apellidos</span>
      <input formControlName="apellidos" type="text" [readonly]="titularAsignado"
        [class.required]="titularForm.get('apellidos').invalid && titularForm.get('apellidos').touched">

      <span>Correo</span>
      <input formControlName="correo" type="email" [readonly]="titularAsignado"
        [class.required]="titularForm.get('correo').invalid && titularForm.get('correo').touched">
      <span>Indicativo</span>
      <div class="fila-indicador">
        <input *ngIf="titularAsignado" type="text" formControlName="indicativo" [readonly]="titularAsignado">
        <app-select-indicativo *ngIf="!titularAsignado" [indicativoForm]="titularForm"
          [nombreCampo]="'indicativo'"></app-select-indicativo>
        <div class="campo-celular">
          <span>Celular</span>
          <input type="number" formControlName="celular" [readonly]="titularAsignado">
        </div>
      </div>
    </div>
    <div class="botones-formulario">
      <button (click)="titularAsignado ? eliminarTitular() : agregarTitular()" class="boton-primario"
        [disabled]="cargando">
        <mat-spinner *ngIf="cargando" class="spinner-blanco" diameter="20" style="margin: 0 auto;"></mat-spinner>
        <span *ngIf="!cargando">{{titularAsignado ? "Eliminar titular" : "Agregar titular"}}</span>
      </button>
    </div>
  </form>

  <app-grupo-familiar *ngSwitchCase="opciones[1]" [grupoFamiliar]="grupoFamiliar"
    (onCambiarInvitadosPermitidos)="cambiarInvitadosPermitidos($event)"></app-grupo-familiar>

  <form class="formulario-inmueble" *ngSwitchCase="opciones[2]" [formGroup]="inmuebleForm">
    <div class="formulario-inmueble-grilla">
      <span>Área</span><input type="text" formControlName="area" readonly>
      <span>Unidad</span><input type="number" formControlName="apartamento" readonly>
      <span>Precio administración</span><input type="number" formControlName="costoAdministracion">
      <span>Estado</span>
      <div class="botones-estado">
        <button [class.boton-primario]="estado === 1" (click)="cambiarEstado(1)">Activo</button>
        <button [class.boton-primario]="estado === 0" (click)="cambiarEstado(0)">Inactivo</button>
      </div>
    </div>
    <app-botones-cambios [mostrar]="inmuebleForm.dirty" (onCancelar)="inmuebleForm.reset(inmuebleFormInitialValues)"
      (onGuardar)="actualizarInformacionInmueble()" style="margin-left: auto;"></app-botones-cambios>
  </form>
</div>